<!-- 게시판글 표현 기본적인거 하나로 통합 -->
<template>
    <div class="wrapper" :class="mode">
        <div class="thumb" v-if="imgview"
        @click="updateCount(post.id, post.document.menu, post.document.name)"        
        >
        <!-- :style="{height:`${imgheight}`+'px',width:`${imgwidth}`+'%'}" -->
        <template v-if="post.attachfile">
            <div class="thumb_box video">
                <div class="mark_wrap" :style="styles('video')">
                    <img :src="`${require('@/assets/imgs/video_mark.png')}`" alt="" class="mark">
                </div>
                <video :style="styles('video')"  :src="attatchfileUrl(post.attachfile)"></video>
            </div>
          
        </template>
        <template v-else>
            <template v-if="getYoutube(post.content)">
            
                    <!--플레이어 형식 
                        <iframe :src="`https://www.youtube.com/embed/${getYoutube(post.content)}?autoplay=1&mute=1&loop=1`"
                    style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;"
                    frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>
                    </iframe> -->

                    <!--썸네일 형식 -->
                <div :style="youtubethumb(post.content)"  class="thumb_box youtube">
                    <img :src="`${require('@/assets/imgs/youtube_black.png')}`" alt="" class="mark">
                </div>            
            </template>
            <template v-else>
                <div :style="styles(post.content)" class="thumb_box" v-if="getImage(post.content)"></div>
                
                <div v-else class="thumb_box" 
                    :style="styles(post.content)">             
                </div>   
            </template>    
        </template>
       
        
        
            <!-- <div v-else class="thumb_box">
                게임조아
                <span>No Image</span>
            </div>            -->
        </div>
        <div class="cont" v-if="titleview">
            <div class="title" :style="{fontWeight:`${fontWeight}`}">
              <span v-if="isDocView">[{{post.document.title}}]</span> <post-title :document="post.document.name" :list="post" :menu="post.document.menu" :isMobile="isMobile" :lengthLimit="titlelength"/>
            </div>           
        </div>
       
    </div>
</template>
<script>
import { removeAllTag } from '@/utils/removetag';
import PostTitle from '@/components/posts/PostTitle.vue';
import { postLink } from '@/utils/menu';
export default {
    props: {
        post: {          
            required: true,
            default: null
        },
        titleview: {
            type: Boolean,
            required: false,
            default: true
        },
        // titlepos:{
        //     type:String,
        //     required:false,
        //     default: 'bottom',    
        // },  
        titlelength:{
            type:Number,
            required:false,         
        }, 
        imgview:{
            type:Boolean,
            required:false,
            default: true,
        },
        imgheight:{
            type:String,
            required:false,    
            default:'80px'            
        },
        imgwidth:{
            type:String,
            required:false,    
            default:'100%'            
        },
        radius:{
            type:Number,
            required:false,  
            default:0       
        },
        mode:{
            type:String,
            required:false,            
        },
        isMobile:{
            required: false,
            default: false,       
        },
        isDocView:{
            required: false,
            default: false,      
        },
        fontWeight:{
            required:false,
            default:'normal'
        }

          
    },   
    components:{       
        PostTitle
    },  
    computed:{
       
    },
    methods:{ 
        attatchfileUrl(fileUrl){
        return this.$store.state.serverDomain2+'storage/'+fileUrl;
        },
        youtubethumb(content){
            return{
                   backgroundImage:'url(https://img.youtube.com/vi/'+this.getYoutube(content)+'/mqdefault.jpg)',
                   'border-radius' : this.radius + 'px',
                    'width' : this.imgwidth,
                    'height': this.imgheight,
                }      
        },
        styles(content){
            if(this.getImage(content))
            {
                return{
                    backgroundImage:'url('+ this.getImage(content)+')',
                    'border-radius' : this.radius + 'px',
                    'width' : this.imgwidth,
                    'height': this.imgheight,
                }
            }else if(content ==="video"){
                return{                  
                   'border-radius' : this.radius + 'px',
                    'width' : this.imgwidth,
                    'height': this.imgheight,
                }    
            }else{
                return{
                   backgroundImage:`url(${require('@/assets/imgs/no_image.png')})`,
                   'border-radius' : this.radius + 'px',
                    'width' : this.imgwidth,
                    'height': this.imgheight,
                }    
            }           
        },
        getYoutube(cont){
            //유투브영상 체크
            const step1 = cont.split('https://youtu.be/');
            if ( step1.length === 1)
            {
                return false;
            }
            //게시판 구분, 게임등급&질의, 멘토리, 뉴스,이슈 게시판만
            const allow =[4,5,6,7,8,9,10,11,12,13,14,26,29];
            if(!allow.includes(this.post.document_id))
            {
                return false;
            }
            const step2 = step1[1].split('">')
            this.isYoutube = true;
            return step2[0];
        },
        getImage(cont)
        {
            const step1 = cont.split('<img src="')           
            if ( step1.length === 1)
            {
                return '';
            } 
            const step2 = step1[1].split('">')
            //웹에서 긁어온 이미지때문에 한번더 파싱
            const step3= step2[0].split('" ')
            return step3[0];         
        },
        getCont(cont)
        {      
            const removetag = removeAllTag(cont);           
            return removetag.substr(0, 130) + (removetag.length >130?'...':'') ;
        },
        updateCount(post_id,menu_title,document)
        {
            const menu = this.$store.getters['menu/getMenu'].find((menus)=>menus.title === menu_title).name;
            postLink(post_id,menu,document,this.$store); 
            if(this.isMobile === 'isMobile')
            { 
                this.$router.push({
                    path: "/m/community/" + menu +"/"+document+"/view/"+post_id                
                }); 
            }else{
                this.$router.push({
                    path: "/main/community/" + menu +"/"+document+"/view/"+post_id                
                }); 
            } 
            
        }

    }
}
</script>
<style lang="scss" scoped>
.blog_left{
    display: flex;    
    .cont{  
        
        padding-left: 10px;
        .title{       
            white-space: normal !important;
           
        }        
    }
}
.blog_right{
    display: flex;  
    flex-direction:row-reverse;
    justify-content: space-between;
    .cont{        
        
        padding-right: 10px;
        .title{       
            white-space: normal !important;
            text-align: left !important;
        }        
    }
}
.wrapper
{   
    .thumb{
         cursor:pointer;
        .thumb_box{
            width:100%;  
            height:100%;           
            background-size:cover;            
            background-color:#dee3eb;
            background-position: center;
            color:#808080;
            display:flex;
            align-items:center;
            justify-content: center;
            font-size:16px;
            flex-direction:column;
            border:1px solid rgb(231, 231, 231);
            span{
                font-size:11px;
                background:#808080;
                border-radius:10px;
                color:#dee3eb;
                padding:0 5px;
            }
        }
    }
    .video{
        position:relative;
        .mark_wrap{
            position:absolute;  
            display: flex;
            align-items: center;  
            justify-content: center;  
            .mark{    
                                    
                opacity:0.8;
                height: 40%; 
            }           
        }        
        
    }
    .youtube{
        display: flex;
        justify-content: center;
        align-items: center;
        .mark{
            height:40%;
            opacity: 0.6;
        }
    }
    .cont{        
        font-family:'나눔고딕';
        .title{       
            margin-top: 5px;
            white-space:nowrap;
            text-overflow:ellipsis;
            overflow-x: hidden;
            text-align: left;
           
        }        
    }
}

</style>